<template>
  <div class="view contentBody">
    <p class="title"><span>角色管理</span>
      <el-button type="primary" @click="addLebel(0)" size="small">添加角色</el-button>
    </p>
    <div class="table_wrap">
      <el-table :data="tagList" style="width: 100%">
        <el-table-column prop="name" label="员工角色" width="200">
        </el-table-column>
        <el-table-column prop="desc" label="描述">
        </el-table-column>
        <el-table-column prop="num" label="员工数量">
        </el-table-column>
        <el-table-column label="操作" align="center" width="300">
          <template slot-scope="scope" v-if="scope.row.is_edit==1">
            <div class="templateSpan">
              <span class="action_btn" @click="addLebel(1,scope.row)">编辑</span>
              <span class="linecenter"></span>
              <span class="action_btn" @click="detelLebel(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- <addColumnLebel :visible.sync="addcolumnlebel" :dialogType="dialogType" :dialogContent="dialogContent"
                    v-if="addcolumnlebel" @initFn="InitFn"></addColumnLebel> -->
  </div>
</template>
<script>
  import api from "@/api.js";
  import addColumnLebel from "@/components/dialog/addColumnLebel.vue";

  export default {
    name: "custom",
    components: {
      addColumnLebel
    },
    data() {
      return {
        tagList: [],
        page: 1
      };
    },
    created() {
      this.InitFn();
    },
    methods: {
      //初始化请求
      InitFn() {
        this.axios
            .post(api.role_index, {page: this.page})
            .then(response => {
              if (response.data.code == 0) {
                this.tagList = response.data.list
              } else {
              }
            })
            .catch(response => {
            });
      },
      addLebel(type_, option_) {
        this.$router.push({name: "enployeemanageEdit", query: {option: JSON.stringify(option_), type_: type_}});
      },
      detelLebel(row) {
        let _this = this
        this.$confirm('确定删除 ' + row.name + ' ?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.axios
              .post(api.role_delete, {role_id: row.id})
              .then(response => {
                if (response.data.code == 0) {
                  _this.InitFn()
                  _this.$message({
                    message: '删除成功',
                  });
                } else {
                }
              })
              .catch(response => {
              });
        }).catch(() => {

        });
      }
    }
  };
</script>
